module.exports = "/_next/static/images/plus-gray400-2172902108c864a2fe14b94c81e2df91.svg";